import { render } from "./PagerItem.vue?vue&type=template&id=5d63d2d4&ts=true"
import script from "./PagerItem.vue?vue&type=script&lang=ts"
export * from "./PagerItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__